import * as React from "react";
import PropTypes from 'prop-types';

const SvgPillSelected = props => {
  if (props.id !== "_svgpillselected") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 16 16" {...props}><g fill="none" fillRule="evenodd"><circle cx={8} cy={8} r={8} fill="#202020" /><g fill="#FFF"><path d="M4.768 7.596l3.535 3.536-1.414 1.414L3.354 9.01z" /><path d="M11.485 5.121L12.9 6.536l-5.656 5.656-1.415-1.414z" /></g></g></svg>;
};

SvgPillSelected.displayName = "_svgpillselected";
SvgPillSelected.propTypes = {
  id: PropTypes.string
};
SvgPillSelected.defaultProps = {
  id: ''
};
export default SvgPillSelected;